import axios from 'axios';
import dicomParser from 'dicom-parser';
import cornerstoneWADOImageLoader from 'cornerstone-wado-image-loader';
import { getHeadersConfig } from '../util/getHeadersConfig';
import { uint8ArrayToString, findBoundary } from '../../loaders/mywadors/getPixelData';
import { WADO_RS_WEB_SERVICE_TYPE } from '../util/useServerConfig';

const { findIndexOfString } = cornerstoneWADOImageLoader.wadors;

export async function downloader(uri, authorizationHeader) {
  const cfg = getHeadersConfig(authorizationHeader);
  // const cfg = {
  //   responseType: 'arraybuffer',
  //   // headers: { Authorization: authorizationHeader },
  // };
  //  uri = '/meta/wadouri';
  //  uri = '/meta/wadors_mod';
  //  uri = '/meta/wadors';

  return axios
    .get(uri, cfg)
    .then((res) => res)
    .catch((error) => error);
}

// Using this for waveforms
export async function getDataSet(uri, authorizationHeader, webServiceType) {
  let dataSet = [];
  let byteArray = [];

  await downloader(uri, authorizationHeader).then((res) => {
    const arrayBuffer = res;
    byteArray = new Uint8Array(arrayBuffer.data);

    let dicomData;

    if (webServiceType === WADO_RS_WEB_SERVICE_TYPE) {
      // First look for the multipart mime header
      const tokenIndex = findIndexOfString(byteArray, '\r\n\r\n');

      if (tokenIndex === -1) {
        throw (new Error('invalid response - no multipart mime header'));
      }

      const header = uint8ArrayToString(byteArray, 0, tokenIndex);

      // Now find the boundary  marker
      const split = header.split('\r\n');
      const boundary = findBoundary(split);

      if (!boundary) {
        throw (new Error('invalid response - no boundary marker'));
      }

      const offset = tokenIndex + 4; // skip over the \r\n\r\n

      // find the terminal boundary marker
      const endIndex = findIndexOfString(byteArray, boundary, offset);

      if (endIndex === -1) {
        throw (new Error('invalid response - terminating boundary not found'));
      }

      // Remove \r\n from the length
      const length = endIndex - 2;

      dicomData = new Uint8Array(byteArray.buffer);
      dicomData = dicomData.slice(offset, length);
      
    } else { // WADO-URI webServiceType
      dicomData = byteArray;
    }

    dataSet = dicomParser.parseDicom(dicomData);
  });

  return { dataSet };
}
